export default "__VITE_ASSET__BfkWT0wZ__"